export const types = {
    FILL_USERS:  'FILL_USERS',
    CLEAR_USERS: 'CLEAR_USERS',

    // Async
    FETCH_USERS_ASYNC: 'FETCH_USERS_ASYNC',
};
